export default __webpack_public_path__ + "static/BrownEntrataWeb-Bold-fe5465b8ec77dccf9e77f9f9410fa206.woff";